import { useEffect, useState } from 'react';

//Pass Json to insert
export const useFetchJson = (url, data, method, token) => {
    const [response, setResponse] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    //console.group("UU: "+url)


    useEffect(() => {
        const myFetch = async(url, data, token) => {
        setLoading(true);
        const res = await fetch(url, {
          method: method, 
          headers: {
             Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
          credentials: 'include',
        })
            .catch((err) => {
                setError(err)
                setLoading(false)
            });
            
        try{  
          const ans = await res.json();
          setResponse(ans)
        } catch (err) {
          setError(err);
        }
            
        setLoading(false);
        }
        myFetch(url, data, token);    }, [url, method, token])
    return { response, loading, error }
}
